import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NB_AUTH_OPTIONS,
  NbAuthSocialLink,
  NbAuthService,
  NbAuthResult,
} from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { NbStepperComponent, NbThemeService } from '@nebular/theme';
import { EMAIL_PATTERN, NUMBERS_PATTERN } from '../constants';
import { InitUserService } from '../../../@theme/services/init-user.service';
// import { AuthService } from '../auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import * as gender from './../../../data/gender.json';
import * as title from './../../../data/title.json';
import { INgxSelectOption } from 'ngx-select-ex';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { OtpVerifyDialogComponent } from '..';
import { UserData } from '../../../@core/interfaces/common/users';
import { log } from 'console';

const branchId= "1";
const userFlag= "Patient";
const loginUserType="patientlogin";

@Component({
  selector: 'ngx-patient-signup',
  templateUrl: './patient-signup.component.html',
  styleUrls: ['./patient-signup.component.css']
})
export class PatientSignupComponent implements OnInit {
  signupForm: FormGroup;
  @ViewChild('otpVerify') otpVerifyInstance: OtpVerifyDialogComponent;
  @ViewChild('stepper') stepperComponentInstance: NbStepperComponent;
  smsdto={"variables":[],"template_id":"","to":"","service":"T"};
  minlength:number =4;
  maxLength:number = 10;
  genderList: string[] = (gender as any).default;
  titleList: any = (title as any).default;
  protected readonly unsubscribe$ = new Subject<void>();
  newUser: any;
  placeholder: string = "Select";
  allowClear: any = true;
  minLength;
  isconfirmation:boolean=false;
  multiple: boolean = false;
  isSubmitted: boolean = false;
  returnData: NbAuthResult;
  otpId: any;
  isPatientExistData: any;
  errorMessage: boolean =false;
  get mobileNumber() { return this.signupForm.get('mobileNumber'); }
  get password() { return this.signupForm.get('password'); }
  get email() { return this.signupForm.get('email'); }
  get fullName() { return this.signupForm.get('fullName'); }
  get confirmPassword() { return this.signupForm.get('confirmPassword'); }
  @Output() diaClose: EventEmitter<any> = new EventEmitter<any>();
  tenantId=environment.patientTenantId;
  constructor(protected service: NbAuthService, protected userService: UserData,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef, protected patRegSrvc: PatientRegistrationData,
    protected themeService: NbThemeService, 
    // protected authService: AuthService,
    private fb: FormBuilder,
    protected router: Router,
    protected initUserService: InitUserService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    const mobileNumberValidators = [
      Validators.pattern(NUMBERS_PATTERN),
    ];
    const passwordValidators = [
      Validators.pattern(NUMBERS_PATTERN),
      Validators.minLength(this.minlength),
      Validators.maxLength(this.maxLength),
    ];

    this.signupForm = this.fb.group({
      fullName: this.fb.control('', [Validators.required,Validators.pattern('^[a-zA-Z-. ]+$')]),
      mobileNumber:this.fb.control(null, [Validators.required, Validators.pattern('^[0-9]+$'), Validators.maxLength(10), Validators.minLength(10)]),
      email: this.fb.control('', [Validators.required,Validators.pattern(EMAIL_PATTERN)]),
      confirmPassword: this.fb.control('', [...passwordValidators]),
      password: this.fb.control('', [...passwordValidators]),
      title:this.fb.control('', [Validators.required]),
      gender:this.fb.control('', [Validators.required, Validators.pattern('^[A-Za-z0-9]+$')]),
      age:this.fb.control(null, [Validators.required, Validators.pattern('^[0-9]+$')])
     
    });
  }
  onTitleChange(event: INgxSelectOption[]) {
    if (event[0].data.value == "1" || event[0].data.value == "5") {
      this.signupForm.controls['gender'].setValue("Male");
    }
    else if (event[0].data.value == "2" || event[0].data.value == "3" || event[0].data.value == "4") {
      this.signupForm.controls['gender'].setValue("Female");
    }
  }
  onFirstSubmit() {
    this.isSubmitted =true;
    this.signupForm.markAsDirty();
  }
  onCancel()
  {
    this.diaClose.emit(null);
    //this.router.navigate(['auth/patient-login']);
  }
  isUserExist(){
    if(this.signupForm.valid)
    {
    this.errorMessage = false;
    var mobileNumber =this.signupForm.get('mobileNumber').value;
    var email =this.signupForm.get('email').value;
    this.userService.userList(`users/isexist/${mobileNumber}/${email}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.isPatientExistData = data;
      

    }, (error) => {

    }, () => {
      console.log("Data = ", this.isPatientExistData)
      if(this.isPatientExistData == null)
      {
        this.sendOtp();
      }
      else
      this.errorMessage = true;
      this.cd.detectChanges();
    });
  }
  }
   sendOtp() {
    if(this.signupForm.valid)
    {
     var mobileNumber =this.signupForm.get('mobileNumber').value;
     this.patRegSrvc.sendMessageOtp("patientportalnewuser/" + environment.patientTenantId +  '/sendotp/' + mobileNumber,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

   // this.patRegSrvc.sendMessageOtp("communication/" + environment.patientTenantId + '/' + environment.patientTenantId + '/sendotp/' + mobileNumber,this.smsdto).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      
      this.otpId = data;

      

    }, (error) => {
     

    }, () => {
     // console.log("otp sent...........", this.isOtpDia);
       this.stepperComponentInstance.next();
      // this.isCustomerExist =false;

      // this.isOtpDia = true;
       this.otpVerifyInstance.fromPatientPortal(mobileNumber,environment.patientTenantId,this.otpId, "PatientPortal")
      this.cd.detectChanges();

    });
   }
  }
  onOtpDiaClose(data: any): void { 
    
    if (data == null)
      {
        this.onCancel(); 
      }
    else if (data.otpStatus == "approved" || data.otpStatus == "success") {

      console.log(".....portal......otp status.......",data);
      this.signup(); 
    } 
  }
  get fval(): { [key: string]: AbstractControl } { return this.signupForm.controls; }

  signup()
  {
    if(this.signupForm.valid)
    { 
    this.newUser = this.signupForm.value;

    let requestData = {
      email: this.signupForm.get('email').value,
      fName: this.signupForm.get('fullName').value, 
      mobileNum: this.signupForm.get('mobileNumber').value,
      tenantId: environment.patientCusID,
      fullName: this.signupForm.get('fullName').value, 
      branchId: branchId,
      userFlag: userFlag,
      loginUserType:loginUserType,
      title:this.signupForm.get('title').value,
      gender:this.signupForm.get('gender').value,
      age:this.signupForm.get('age').value,
      password:this.signupForm.get('password').value,
      confirmPassword:this.signupForm.get('confirmPassword').value 
    }
    this.service.register("email", requestData).subscribe((result: NbAuthResult) => {
     
      if (result.isSuccess()) {
        this.returnData = result;
        this.onCancel();
      }
            this.cd.detectChanges();
            
    },()=>{
      this.onCancel();
      this.cd.detectChanges();
    });
  }
    // this.authService.patientRegister(this.newUser ).pipe(takeUntil(this.unsubscribe$)).subscribe((result: NbAuthResult) => {
      
    // }, (error) => {
    // }, () => {
    //   this.cd.detectChanges();
    // });
  }

}
